export default {
  aboutUs: {},
};
